class NewsletterSubmit {
	constructor(el) {
		this.el = el;
		this.displayChevronIcon();
	}

	displayChevronIcon () {
		const newsletterSubmit = this.el.querySelector('.gform_button');
		if (newsletterSubmit) {
			newsletterSubmit.value = '';
		}
	}


}

export default NewsletterSubmit;
